import { jsxs as d, jsx as r } from "react/jsx-runtime";
import { forwardRef as u, useCallback as v } from "react";
import o from "./styles.module.less.js";
import h from "./chevron-down.svg.js";
const w = u((a, p) => {
  var s;
  const { value: t, options: c, disabled: n, onChange: l, error: i } = a, m = v((e) => {
    n || l(e.target.value);
  }, [n, l]);
  return /* @__PURE__ */ d("div", { className: `${o.dropdownInputWrapper} ${i ? o.error : ""}`, children: [
    /* @__PURE__ */ d(
      "select",
      {
        ref: p,
        ...a.props,
        className: `${o.dropdownInput} ${((s = a.props) == null ? void 0 : s.className) || ""}`,
        value: t || "",
        onChange: m,
        disabled: n,
        children: [
          /* @__PURE__ */ r("option", { value: "", children: "Please select" }),
          c.map((e) => /* @__PURE__ */ r("option", { value: e.value, className: o.dropdownOption, children: e.label }, e.value))
        ]
      }
    ),
    /* @__PURE__ */ r("div", { className: o.dropdownIcon, children: /* @__PURE__ */ r(h, {}) })
  ] });
});
w.displayName = "DropdownInput";
export {
  w as DropdownInput
};
